import React, { useState } from "react";
import { Container, Form, Button, Alert } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import emailjs from "@emailjs/browser";
import Seo from "./Seo";

const EMAILJS_SERVICE_ID  = "service_fccgcs6";
const EMAILJS_TEMPLATE_ID = "template_zthqueg";
const EMAILJS_PUBLIC_KEY  = "pSNMBUa9OOBXgMdpq";

function ContactUs() {
  const { t } = useTranslation();
  const [fields, setFields] = useState({ name: "", email: "", message: "" });
  const [status, setStatus] = useState(null); // "sending" | "success" | "error"

  function handleChange(e) {
    setFields((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setStatus("sending");
    try {
      await emailjs.send(
        EMAILJS_SERVICE_ID,
        EMAILJS_TEMPLATE_ID,
        { name: fields.name, email: fields.email, message: fields.message, title: fields.name },
        EMAILJS_PUBLIC_KEY
      );
      setStatus("success");
      setFields({ name: "", email: "", message: "" });
    } catch (err) {
      console.error("EmailJS error:", err);
      setStatus("error");
    }
  }

  return (
    <Container style={{ paddingTop: 24, paddingBottom: 60, maxWidth: 640 }}>
      <Seo
        title={t("contact.pageTitle")}
        description={t("contact.pageDesc")}
        canonical="/contact-us"
      />
      <h1>{t("contact.h1")}</h1>
      {status === "success" && <Alert variant="success">Message sent successfully!</Alert>}
      {status === "error"   && <Alert variant="danger">Something went wrong. Please try again.</Alert>}
      <Form onSubmit={handleSubmit}>
        <Form.Group controlId="formName" className="mb-3">
          <Form.Label>{t("contact.name")}</Form.Label>
          <Form.Control
            type="text"
            name="name"
            value={fields.name}
            placeholder={t("contact.namePlaceholder")}
            onChange={handleChange}
            required
          />
        </Form.Group>
        <Form.Group controlId="formEmail" className="mb-3">
          <Form.Label>{t("contact.email")}</Form.Label>
          <Form.Control
            type="email"
            name="email"
            value={fields.email}
            placeholder={t("contact.emailPlaceholder")}
            onChange={handleChange}
            required
          />
        </Form.Group>
        <Form.Group controlId="formMessage" className="mb-3">
          <Form.Label>{t("contact.message")}</Form.Label>
          <Form.Control
            as="textarea"
            rows={4}
            name="message"
            value={fields.message}
            placeholder={t("contact.messagePlaceholder")}
            onChange={handleChange}
            required
          />
        </Form.Group>
        <Button variant="primary" type="submit" disabled={status === "sending"}>
          {status === "sending" ? "Sending…" : t("contact.submit")}
        </Button>
      </Form>
    </Container>
  );
}

export default ContactUs;
